import { FileTypes } from "../../../../enums/FileUploadEnums";
import { InputfieldTypes } from "../../../../enums/InputFieldAttributesEnums";
import { jobStatus } from "../constants";

export const fileUploadProps = {
  maxFileCount: 5,
  defaultSheetStatus: "Pending",
  fileUploadSuccessMessage: "Upload Completed!",
  uploadingMessage: "Uploading",
  fileSizeWarning: "Max file size is 10MB",
};

export const ApprovalStatus = {
  pending: "Pending",
  approved: "Approved",
  rejected: "Rejected",
};

export const ImageAltText = {
  pdfAltText: "PDF ICON",
};

export const ButtonTitles = {
  uploadButtonTitle: "Upload File",
};

export const BondStatusLabel = {
  bonded: "Bonded",
  notBonded: "Not Bonded",
};

export const BondStatusValue = {
  bonded: "bonded",
  notBonded: "notBonded",
};

export const InternalApprovalMessages = {
  fileUploadCancelled: "File Upload Cancelled",
};

export const internalApprovalInputFields = {
  jobSiteAddress: "jobSiteAddress",
  jobSiteAddressCoordinates: "jobSiteAddressCoordinates",
  cashOrCreditSale: "cashOrCreditSale",
};

export const invoiceNotesFields = [
  {
    type: InputfieldTypes.TEXT_AREA,
    name: "poInfo1",
    placeHolder: "Add Notes",
    maxLength: 25,
    showCount: true,
    rows: 1,
  },
  {
    type: InputfieldTypes.TEXT_AREA,
    name: "poInfo2",
    placeHolder: "Add Notes",
    maxLength: 25,
    showCount: true,
    rows: 1,
  },
  {
    type: InputfieldTypes.TEXT_AREA,
    name: "poInfo3",
    placeHolder: "Add Notes",
    maxLength: 25,
    showCount: true,
    rows: 1,
  },
  {
    type: InputfieldTypes.TEXT_AREA,
    name: "poInfo4",
    placeHolder: "Add Notes",
    maxLength: 25,
    showCount: true,
    rows: 1,
  },
];

export const onSiteContactFields = [
  {
    type: InputfieldTypes.TEXT,
    name: "onSiteContactName",
    placeholder: "Enter name",
    label: "Name",
    requiredField: true,
  },
  {
    type: InputfieldTypes.ONCHANGE_TEXT,
    name: "onSiteContactPhone",
    placeholder: "Enter phone",
    label: "Phone",
    requiredField: true,
  },
  {
    type: InputfieldTypes.TEXT,
    name: "onSiteContactEmail",
    placeholder: "Enter email",
    label: "Email",
    requiredField: true,
  },
];

export const projectCoordinateFields = [
  {
    type: InputfieldTypes.GOOGLE,
    name: "jobSiteAddress",
    label: "Job Site Address",
    placeholder: "Enter address",
    isJobSiteAddress: true,
    requiredField: true,
  },
  {
    type: InputfieldTypes.TEXT,
    name: "jobSiteAddressCoordinates",
    placeholder: "Enter coordinates",
    label: "Job Site Coordinates",
  },
];

export const internalApprovalHeaders = {
  projectDetailsHeader: "Project Details",
  onSiteContactHeader: "On-Site Contact",
  projectCoordinatesHeader: "Project Coordinates",
  projectBondStatusHeader: "Project Bond Status",
  customerApprovalAggrementHeader: "Customer Approval Agreement",
  taxExemptDocumentHeader: "Tax Exempt Document",
  overallProjectInformationSheetHeader: "Overall Project Information Sheet",
  cashOrCreditSaleHeader: "Project Documents",
  invoiceNotesHeader: "Invoice Notes",
  invoiceNotesSubHeader: "(Ex job & PO Number)",
  warningContent: "Warning: Will display on invoice exactly as typed",
  notBondedFallBack: "Not bonded",
};

export const noDocumentFoundMessages = {
  noProjectInformationSheet: "No project information sheet",
  noTaxExemptDocument: "No tax exempt document",
};

export const taxExemptStatusLabel = {
  exempt: "Exempt",
  notExempt: "Not Exempt",
};

export const taxExemptStatusValue = {
  exempt: "exempt",
  notExempt: "notExempt",
};

export const modalHeaders = {
  taxExemptModalHeader: "Upload Tax Exempt Document",
  bondInfoModalHeader: "Upload Bond Info Document",
  projectInformationSheetHeader: "Upload Project Information Sheet",
  projectBondHeader: "Upload Project Bond Documents",
  projectInfoSectionHeader: "Upload Project Info Section Documents",
  propertyLegalDescriptionHeader: "Upload Property Legal Description Documents",
  propertyOwnerInformationHeader: "Upload Property Owner Information Documents",
  generalOwnerInformationHeader:
    "Upload General Contractor Information Documents",
  subContractorOwnerHeader: "Upload Subcontractor Information Documents",
};

export const taxExemptRadioOptions = [
  { label: "Exempt", value: "exempt" },
  { label: "Not Exempt", value: "notExempt" },
];

export const inputFieldsName = {
  taxExemptButton: "taxExemptStatus",
  projectBondButton: "projectBondStatus",
};

export const InteralApprovalPageConstants = {
  PROJECT_BOND_STATUS_SUBHEADING: "Project Bond Status",
};

export const internalApprovalBeforeStates = [
  jobStatus.materialTruckDetails,
  jobStatus.buildQuote,
  jobStatus.quoteShared,
  jobStatus.quoteApproved,
  jobStatus.l1ApprovalPending,
];

export const fileTypePermissions = [
    FileTypes.PDF,
    FileTypes.DOC,
    FileTypes.DOCX,
    FileTypes.XLS,
    FileTypes.XLSX,
    FileTypes.CSV,
    FileTypes.JPEG,
    FileTypes.JPG,
    FileTypes.PNG
];
